
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in-sso",
      function () {
        return require("private-next-pages/sign-in-sso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-in-sso"])
      });
    }
  